import { Box } from "@mui/material";
import NavBar from "./NavBar";

type Props = {
    children?: React.ReactNode;
};

export const PageLayout: React.FC<Props> = ({ children }) => {
    return (
        <>
            <NavBar />
            {/* Main Content */}
            {/* fit-content grows this box to its content's min-content width when the viewport is narrower.
                Without it, pages centered with justify-content overflow equally on both sides and the
                left overflow is unreachable by scrolling; it also keeps the right padding in the scroll area. */}
            <Box sx={{ marginTop: "75px", padding: "16px", minHeight: "calc(100vh - 75px)", width: "fit-content", minWidth: "100%" }}>
                {children}
            </Box>
        </>
    );
};